export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-xbox-2d52aff2ead3166f123898a0703031a1.svg";